import { render, staticRenderFns } from "./CouponKiko.vue?vue&type=template&id=d05f5d5c&scoped=true"
import script from "./CouponKiko.vue?vue&type=script&lang=js"
export * from "./CouponKiko.vue?vue&type=script&lang=js"
import style0 from "./CouponKiko.vue?vue&type=style&index=0&id=d05f5d5c&prod&lang=less&scoped=true"
import style1 from "./CouponKiko.vue?vue&type=style&index=1&id=d05f5d5c&prod&lang=scss"
import style2 from "./CouponKiko.vue?vue&type=style&index=2&id=d05f5d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05f5d5c",
  null
  
)

export default component.exports